module.exports = {
  API_URL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
  GOOGLE_MAPS_API_KEY: process.env.VUE_APP_GOOGLE_MAPS_API_KEY || 'YOUR_GOOGLE_MAPS_API_KEY'
}
